export const onNextTick = (callback: () => void) => {
	Promise.resolve().then(callback);
};
